import { render, staticRenderFns } from "./registrationDialog.vue?vue&type=template&id=6937afd2&scoped=true&"
import script from "./registrationDialog.vue?vue&type=script&lang=js&"
export * from "./registrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./registrationDialog.vue?vue&type=style&index=0&id=6937afd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6937afd2",
  null
  
)

export default component.exports